import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// STORE
import { AuthActions } from '@/store/actions';

const CheckAuth = ({
  children,
  isAuth,
  manageAuthDialogState,
  authDrawerOpen,
  type,
  authComponentProps,
}) => {
  const closeAccess = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const data = { ...authComponentProps, callback: children.props.onClick };

    if (type === 'drawer') {
      authDrawerOpen(data);
    } else {
      manageAuthDialogState(data);
    }
  };

  return isAuth ? children : React.cloneElement(children, { onClick: closeAccess });
};

CheckAuth.defaultProps = {
  type: 'dialog',
  authComponentProps: {},
};

CheckAuth.propTypes = {
  type: PropTypes.string, // dialog || drawer
  children: PropTypes.node.isRequired,
  isAuth: PropTypes.bool.isRequired,
  authDrawerOpen: PropTypes.func.isRequired,
  manageAuthDialogState: PropTypes.func.isRequired,
  authComponentProps: PropTypes.object,
};

const mapStateToProps = ({ auth }) => ({
  isAuth: auth.isAuth,
});

const mapDispatchToProps = dispatch => {
  return {
    authDrawerOpen: data => dispatch(AuthActions.authDrawerOpen.action({ data })),
    manageAuthDialogState: props =>
      dispatch(AuthActions.manageAuthDialogState.action({ state: true, props })),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckAuth);
